import React, { MouseEvent, ReactElement } from 'react';
import { Icon } from '../../../../../../../components/CiscoUi';
import styles from './index.module.css';

export type NodeDeleteButtonProps = {
  name: string;
  onClick?: VoidFunction;
};

export const NodeDeleteButton = ({
  name,
  onClick,
}: NodeDeleteButtonProps): ReactElement => {
  if (onClick === undefined) return <></>;

  const handleOnClick = (event: MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    onClick();
  };

  return (
    <div
      className={styles.root}
      onClick={(event) => handleOnClick(event)}
      aria-label={`Delete ${name} Node`}
      role="button"
    >
      <Icon name="trash" className={styles.icon} />
    </div>
  );
};
